var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseContent',[_c('BaseSection',{attrs:{"title":"History","padded":""}},[_c('p',{staticClass:"timezone-note"},[_vm._v(" Showing times in "+_vm._s(_setup.clientTimezoneLabel)+" ")]),_c(_setup.ShowScheduleMixBlock,{attrs:{"resources":_setup.stationsPlaylist}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }